import { useContext } from 'react';
import { ServicesContext } from './services-context';

/**
 * Hook to access services from context
 */
export const useServices = () => {
  const context = useContext(ServicesContext);
  if (!context) {
    throw new Error('useServices must be used within a ServicesProvider');
  }
  return context;
};
